import { combineReducers } from 'redux';
import drama from './drama';
import authModal from './authModal';
import campaignModal from './campaignModal';
import campaignSource from './campaignSource';
import campaignStep from './campaignStep';

export default combineReducers({ drama, authModal, campaignModal, campaignSource, campaignStep });
